import * as React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const P = ({ children, additionalStyle }) => {
  return (
    <>
      <p className={cn('text-gray-700 text-sm leading-6', additionalStyle)}>{children}</p>
    </>
  );
};

P.propTypes = {
  children: PropTypes.node.isRequired,
  additionalStyle: PropTypes.string,
};

export default P;
